import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OpdataCalc,DataOutputModelCalc } from 'src/app/models/opdataCalc.model';
import { Stage } from 'src/app/models/role.model';
import { Train } from 'src/app/models/train.model';
import { OpdataService } from 'src/app/services/opdata/opdata.service';
import { TrainService } from 'src/app/services/trains/trains.service';
import { PlotlyService } from '../plotly.service';
import { RawCalcTrainDataViewModel } from 'src/app/models/OpRawCalc.model';
import { Plant } from 'src/app/models/plant.model';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { EventLogs } from 'src/app/models/eventLog.model';
import { EventlogsService } from 'src/app/services/eventlogs/eventlogs.service';
import html2canvas from 'html2canvas';
import { Opdata } from 'src/app/models/opdata.model';
import {PagingHeader,QueryStringParameters,} from 'src/app/shared/shared.model';
import { DataOutputModel } from 'src/app/models/opdata.model';
@Component({
  selector: 'app-customgraph',
  templateUrl: './customgraph.component.html',
  styleUrls: ['./customgraph.component.scss'],
})
export class CustomgraphComponent {
  @ViewChild('captureArea', { static: false }) captureArea: ElementRef;
  public WindowRef: Window;
  NewWidth: any;
  field1: string = '';
  field2: string = '';
  field3: string = '';

  field1Name: string = '';
  field2Name: string = '';
  field3Name: string = '';

  Stage1: string = '1';
  Stage2: string = '1';
  Stage3: string = '1';

  fieldDDl = [];
  OGList = [];

  title: string = '';
  queryParam: QueryStringParameters = new QueryStringParameters();
  pageHeaders: PagingHeader = new PagingHeader();
  queryParamcalc: QueryStringParameters = new QueryStringParameters();
  pageHeaderscalc: PagingHeader = new PagingHeader();
  loggedInUserRole: string;
  loggedinUserId: string;
  plantAndUserId: string;

  opCalData: RawCalcTrainDataViewModel[] = [];
  rawopdata:Opdata[]=[];
  calcOpdta:OpdataCalc[]=[];
  optimizedOpdata:RawCalcTrainDataViewModel[] = [];
  plantName: string = '';
  trainDetails: Train = new Train();
  trainId: string = '';
  plantId: string = '';
  graphName: string = '';
  graphName2: string = '';
  graphName3: string = '';
  showselector: boolean = false;
  selections: boolean = true;
  defaultstage: number;
  Eventlogs: EventLogs[] = [];

  maxField1: number;
  maxField2: number;
  maxField3: number;

  F1Name: string;
  F2Name: string;
  F3Name: string;

  downloadbtn: boolean = false;

  public stage2: Array<Stage> = [
    { Id: 1, Name: 'Total' },
    { Id: 2, Name: '1' },
    { Id: 3, Name: '2' },

   
  ];

  public stage3: Array<Stage> = [
   
    { Id: 1, Name: 'Total' },
    { Id: 2, Name: '1' },
    { Id: 3, Name: '2' },
    { Id: 4, Name: '3' },
  ];

  public stageTotal: Array<Stage> = [{ Id: 1, Name: 'Total' }];

  UDFieldList = [
    'User Defined 1',
    'User Defined 2',
    'User Defined 3',
    'User Defined 4',
    'User Defined 5',
  ];
  UDSelectedF1: boolean = true;
  UDSelectedF2: boolean = true;
  UDSelectedF3: boolean = true;

  plants: Plant[] = [];
  trains: Train[] = [];
  plantDetails: Plant = new Plant();

  

    constructor(
    private plot: PlotlyService,
    private plantService: PlantsService,
    private trainService: TrainService,
    private route: ActivatedRoute,
    private router: Router, 
    private opdataService: OpdataService,
    private EventlogsService: EventlogsService
  ) {

    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state || history.state;
    
    if (state && state.trainId) {
    
      this.showselector = state.showselector ?? false;
      this.selections = state.selections ?? false;
      this.trainId = state.trainId;
      this.plantId = state.plantId || null;
      this.plantName = state.plantName || undefined;
      
      console.log("Constructor - State received:", {
        showselector: this.showselector,
        selections: this.selections,
        trainId: this.trainId,
        plantId: this.plantId,
        plantName: this.plantName
      });
    } else {
     
      this.route.queryParams.subscribe((params) => {
        if (params['trainId']) {
          this.showselector = params['showselector'] === 'true' || params['showselector'] === true;
          this.selections = params['selections'] === 'true' || params['selections'] === true;
          this.trainId = atob(params['trainId']!);
          
          this.plantId = params['plantId'] ? atob(params['plantId']!) : null;
          this.plantName = params['plantName'] ? atob(params['plantName']!) : undefined;
          
          console.log("Constructor - Query params (fallback)");
        } else {
          console.error("No state or query params found!");
        }
      });
    }
  }


  appendToList(newItems: { value: string; label: string }[]) {
    this.fieldDDl = [...this.fieldDDl, ...newItems];
  }

  listAdder() {

    this.fieldDDl = this.OGList;
    if (this.trainDetails.Ud1.length > 1) {
      const Ud1 = [{ value: 'ud1', label: this.trainDetails.Ud1 }];
      this.appendToList(Ud1);
    }
    if (this.trainDetails.Ud2.length > 1) {
      const Ud2 = [{ value: 'ud2', label: this.trainDetails.Ud2 }];
      this.appendToList(Ud2);
    }
    if (this.trainDetails.Ud3.length > 1) {
      const Ud3 = [{ value: 'ud3', label: this.trainDetails.Ud3 }];
      this.appendToList(Ud3);
    }
    if (this.trainDetails.Ud4.length > 1) {
      const Ud4 = [{ value: 'ud4', label: this.trainDetails.Ud4 }];
      this.appendToList(Ud4);
    }
    if (this.trainDetails.Ud5.length > 1) {
      const Ud5 = [{ value: 'ud5', label: this.trainDetails.Ud5 }];
      this.appendToList(Ud5);
    }
  }

  getSelectedId(e) {
    this.plantId = e.target.value;
    this.plantService.getPlant(this.plantId).subscribe({
      next: (response) => {
        this.plantDetails = response;
        console.log(this.plantDetails);
        this.plantName = this.plantDetails.Name;
      },
    });

    if (this.loggedInUserRole == 'Standard User') {
      this.plantAndUserId = this.plantId + 'Z' + this.loggedinUserId;
      this.trainService
        .GetAccessibleTrainListByPlantId(this.plantAndUserId)

        .subscribe(
          (response: Train[]) => {
            this.trains = response;
          },
          (error: any) => {
            console.log('error list');
          }
        );
    } else {
      this.trainService.getTrainByPlantId(this.plantId).subscribe(
        (response: Train[]) => {
          this.trains = response;
        },
        (error: any) => {
          console.log('error list');
        }
      );
    }
  }

  
  getSelectedTrainId(e) {
    this.trainId = e.target.value;
    this.selections = false;
    this.getTrainById();
    this.opCalData=[];
  }

  ngOnInit(): void {
    this.WindowRef = window;
    console.log(this.WindowRef.innerWidth);
    this.NewWidth = 1500;
    if (this.WindowRef.innerWidth > 1500) {
      this.NewWidth = this.WindowRef.innerWidth;
    }

    this.fieldDDl = [{ value: '', label: 'Select Field' }];

    if (this.plantId === '' || this.plantId === '') {
      this.plantloader();
    } else {
      this.getTrainById();
    }

     //Subscribe to selectedPlant$ to get the plantId when it changes
    this.plantService.selectedPlant$.subscribe(plantId => {
      if (plantId) {
        this.getSelectedId({
          target: {
            value: plantId
          }
        });
      }
    });
        

    // Subscribe to selectedTrain$ to get the trainId when it changes
    this.plantService.selectedTrain$.subscribe(trainId => {
      if (trainId) {
        this.trainId = trainId.toString();
        this.getSelectedTrainId({
          target: {
            value: this.trainId
          }
        });
      }
    });
  }

  FieldLoader(Unit) {
    let Unit1 = [
      { value: '', label: 'Select Field' },
      { value: 'ph', label: 'Feed pH' },
      { value: 'temp', label: 'Feed Temp (°C)' },
      { value: 'feed_cond', label: 'Feed Conductivity (µS/cm)' },
      { value: 'feed_flow', label: 'Feed Flow (m3/hr)' },
      { value: 'feed_press', label: 'Feed Pressure (bar)' },
      { value: 'conc_flow', label: 'Concentrate Flow (m3/hr)' },
      { value: 'conc_press', label: 'Concentrate Pressure (bar)' },
      { value: 'perm_cond', label: 'Permeate Conductivity (µS/cm)' },
      { value: 'perm_flow', label: 'Permeate Flow (m3/hr)' },
      { value: 'perm_press', label: 'Permeate Pressure (bar)' },
      { value: 'recovery', label: 'Recovery (%)' },
      { value: 'flux', label: 'Flux (lmh)' },
      { value: 'dp', label: 'Differential Pressure (bar)' },
      { value: 'tmp', label: 'TMP (bar)' },
      { value: 'feed_tds', label: 'Feed TDS (ppm)' },
      { value: 'perm_tds', label: 'Permeate TDS (ppm)' },
      { value: 'aftds', label: 'AFTDS (ppm)' },
      { value: 'afop', label: 'AFOP (bar)' },
      { value: 'pop', label: 'POP (bar)' },
      { value: 'net_driv_press', label: 'Net Driving Pressure (bar)' },
      { value: 'a_val', label: 'A Value (gfd/psi)' },
      { value: 'b_val', label: 'B Value (m/s)' },
      { value: 'npf', label: 'Normalized Permeate Flow (m3/hr)' },
      { value: 'nsp', label: 'Normalized Salt Passage (%)' },
      {
        value: 'norm_diff_press',
        label: 'Normalized Differential Pressure (bar)',
      },
    ];

    let Unit2 = [
      { value: '', label: 'Select Field' },
      { value: 'ph', label: 'Feed pH' },
      { value: 'temp', label: 'Feed Temp (°C)' },
      { value: 'feed_cond', label: 'Feed Conductivity (µS/cm)' },
      { value: 'feed_flow', label: 'Feed Flow (gpm)' },
      { value: 'feed_press', label: 'Feed Pressure (psi)' },
      { value: 'conc_flow', label: 'Concentrate Flow (gpm)' },
      { value: 'conc_press', label: 'Concentrate Pressure (psi)' },
      { value: 'perm_cond', label: 'Permeate Conductivity (µS/cm)' },
      { value: 'perm_flow', label: 'Permeate Flow (gpm)' },
      { value: 'perm_press', label: 'Permeate Pressure (psi)' },
      { value: 'recovery', label: 'Recovery (%)' },
      { value: 'flux', label: 'Flux (gfd)' },
      { value: 'dp', label: 'Differential Pressure (psi)' },
      { value: 'tmp', label: 'TMP (psi)' },
      { value: 'feed_tds', label: 'Feed TDS (ppm)' },
      { value: 'perm_tds', label: 'Permeate TDS (ppm)' },
      { value: 'aftds', label: 'AFTDS (ppm)' },
      { value: 'afop', label: 'AFOP (psi)' },
      { value: 'pop', label: 'POP (psi)' },
      { value: 'net_driv_press', label: 'Net Driving Pressure (psi)' },
      { value: 'a_val', label: 'A Value (gfd/psi)' },
      { value: 'b_val', label: 'B Value (m/s)' },
      { value: 'npf', label: 'Normalized Permeate Flow (gpm)' },
      { value: 'nsp', label: 'Normalized Salt Passage (%)' },
      {
        value: 'norm_diff_press',
        label: 'Normalized Differential Pressure (psi)',
      },
    ];
    if (Unit) {
      this.fieldDDl = Unit1;
    } else {
      this.fieldDDl = Unit2;
    }

    this.OGList = this.fieldDDl;
  }

  plantloader() {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (loggedInuserRole.role == 'Standard User') {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;
      this.plantService.getPlantsByUserId(loggedInuserRole.userId).subscribe({
        next: (plants) => {
          this.plants = plants;
        },
      });
    } else {
      this.plantService.getAllPlant().subscribe({
        next: (plants) => {
          this.plants = plants;
        },
        error: (response) => {
          console.log(response);
        },
      });
    }
  }

  getName(type) {}

  onOptionSelectedfield_1(event: any) {
    if (event.target.value == '') {
      this.field1Name = '';
    } else {
      this.field1Name =
        this.fieldDDl[event.target['options'].selectedIndex].label;
    }
    if (this.UDFieldList.includes(this.field1Name)) {
      this.UDSelectedF1 = false;
    }
    else{
        this.UDSelectedF1 = true;
    }
  }

  onOptionSelectedfield_2(event: any) {
    if (event.target.value == '') {
      this.field2Name = '';
    } else {
      this.field2Name =
        this.fieldDDl[event.target['options'].selectedIndex].label;
    }
    if (this.UDFieldList.includes(this.field2Name)) {
      this.UDSelectedF2 = false;
    }
  }

  onOptionSelectedfield_3(event: any) {
    if (event.target.value == '') {
      this.field3Name = '';
    } else {
      this.field3Name =
        this.fieldDDl[event.target['options'].selectedIndex].label;
    }
    if (this.UDFieldList.includes(this.field2Name)) {
      this.UDSelectedF3 = false;
    }
  }

  showGraph() {
    this.downloadbtn = true;
    this.getCalcData();
  }

  getTrainById() {
    console.log(this.trainId);
    this.trainService.getTrainById(this.trainId).subscribe({
      next: (response) => {
        this.trainDetails = response;
        if (this.trainDetails.Units == 0) {
          this.FieldLoader(true)
        } else {
          this.FieldLoader(false)
        }
        this.listAdder();
      },
    });
  }

  getFieldName(stage, field): string {
    if (stage == '1') {
      const fieldMap = {
        ph: 'Ph',
        temp: 'Temp',
        feed_cond: 'TotalFeedCond',
        feed_flow: 'TotalFeedFlow',
        feed_press: 'TotalFeedPress',
        conc_flow: 'TotalConcFlow',
        conc_press: 'TotalConcPress',
        perm_cond: 'TotalPermCond',
        perm_flow: 'TotalPermFlow',
        perm_press: 'TotalPermPress',
        recovery: 'TotalRecovery',
        flux: 'TotalFlux',
        dp: 'TotalDiffPressure',
        tmp: 'TotalTmp',
        net_driv_press: 'TotalNetDrivPress',
        a_val: 'TotalAVal',
        b_val: 'TotalBVal',
        npf: 'TotalNpf',
        nsp: 'TotalNsp',
        norm_diff_press: 'TotalNormDiffPress',
        feed_tds: 'TotalFeedTds',
        perm_tds: 'TotalPermTds',
        aftds: 'S1Aftds',
        afop: 'TotalAvgFeedOp',
        pop: 'TotalPop',
        ud1: 'Ud1',
        ud2: 'Ud2',
        ud3: 'Ud3',
        ud4: 'Ud4',
        ud5: 'Ud5',
      };

      return fieldMap[field] || '';
    }
    if (stage == '2') {
      const fieldMap = {
        ph: 'Ph',
        temp: 'Temp',
        feed_cond: 'S1FeedCond',
        feed_flow: 'S1FeedFlow',
        feed_press: 'S1FeedPress',
        conc_flow: 'S1ConcFlow',
        conc_press: 'S1ConcPress',
        perm_cond: 'S1PermCond',
        perm_flow: 'S1PermFlow',
        perm_press: 'S1PermPress',
        recovery: 'S1Recovery',
        flux: 'S1Flux',
        dp: 'S1Dp',
        tmp: 'S1Tmp',
        net_driv_press: 'S1NetDrivPress',
        a_val: 'S1AVal',
        b_val: 'S1BVal',
        npf: 'S1Npf',
        nsp: 'S1Nsp',
        norm_diff_press: 'S1NormDiffPress',
        feed_tds: 'S1FeedTds',
        perm_tds: 'S1PermTds',
        aftds: 'S1Aftds',
        afop: 'S1AvgFeedOp',
        pop: 'S1Pop',
        ud1: 'Ud1',
        ud2: 'Ud2',
        ud3: 'Ud3',
        ud4: 'Ud4',
        ud5: 'Ud5',
      };

      return fieldMap[field] || '';
    }
    if (stage == '3') {
      const fieldMap = {
        ph: 'Ph',
        temp: 'Temp',
        feed_cond: 'S2FeedCond',
        feed_flow: 'S2FeedFlow',
        feed_press: 'S2FeedPress',
        conc_flow: 'S2ConcFlow',
        conc_press: 'S2ConcPress',
        perm_cond: 'S2PermCond',
        perm_flow: 'S2PermFlow',
        perm_press: 'S2PermPress',
        recovery: 'S2Recovery',
        flux: 'S2Flux',
        dp: 'S2Dp',
        tmp: 'S2Tmp',
        net_driv_press: 'S2NetDrivPress',
        a_val: 'S2AVal',
        b_val: 'S2BVal',
        npf: 'S2Npf',
        nsp: 'S2Nsp',
        norm_diff_press: 'S2NormDiffPress',
        feed_tds: 'S2FeedTds',
        perm_tds: 'S2PermTds',
        aftds: 'S2Aftds',
        afop: 'S2AvgFeedOp',
        pop: 'S2Pop',
        ud1: 'Ud1',
        ud2: 'Ud2',
        ud3: 'Ud3',
        ud4: 'Ud4',
        ud5: 'Ud5',
      };

      return fieldMap[field] || '';
    }
    if (stage == '4') {
      const fieldMap = {
        ph: 'Ph',
        temp: 'Temp',
        feed_cond: 'S3FeedCond',
        feed_flow: 'S3FeedFlow',
        feed_press: 'S3FeedPress',
        conc_flow: 'S3ConcFlow',
        conc_press: 'S3ConcPress',
        perm_cond: 'S3PermCond',
        perm_flow: 'S3PermFlow',
        perm_press: 'S3PermPress',
        recovery: 'S3Recovery',
        flux: 'S3Flux',
        dp: 'S3Dp',
        tmp: 'S3Tmp',
        net_driv_press: 'S3NetDrivPress',
        a_val: 'S3AVal',
        b_val: 'S3BVal',
        npf: 'S3Npf',
        nsp: 'S3Nsp',
        norm_diff_press: 'S3NormDiffPress',
        feed_tds: 'S3FeedTds',
        perm_tds: 'S3PermTds',
        aftds: 'S2Aftds',
        afop: 'S3AvgFeedOp',
        pop: 'S3Pop',
        ud1: 'Ud1',
        ud2: 'Ud2',
        ud3: 'Ud3',
        ud4: 'Ud4',
        ud5: 'Ud5',
      };

      return fieldMap[field] || '';
    } else {
      const fieldMap = {
        ph: 'Ph',
        temp: 'Temp',
        feed_cond: 'S1FeedCond',
        feed_flow: 'S1FeedFlow',
        feed_press: 'S1FeedPress',
        conc_flow: 'S1ConcFlow',
        conc_press: 'S1ConcPress',
        perm_cond: 'S1PermCond',
        perm_flow: 'S1PermFlow',
        perm_press: 'S1PermPress',
        recovery: 'S1Recovery',
        flux: 'S1Flux',
        dp: 'S1Dp',
        tmp: 'S1Tmp',
        net_driv_press: 'S1NetDrivPress',
        a_val: 'S1AVal',
        b_val: 'S1BVal',
        npf: 'S1Npf',
        nsp: 'S1Nsp',
        norm_diff_press: 'S1NormDiffPress',
        feed_tds: 'S1FeedTds',
        perm_tds: 'S1PermTds',
        aftds: 'S1Aftds',
        afop: 'S1AvgFeedOp',
        pop: 'S1Pop',
        ud1: 'Ud1',
        ud2: 'Ud2',
        ud3: 'Ud3',
        ud4: 'Ud4',
        ud5: 'Ud5',
      };

      return fieldMap[field] || '';
    }
  }

  captureScreen() {
    const element = this.captureArea.nativeElement;
    html2canvas(element).then(canvas => {
        const dataUrl = canvas.toDataURL("image/png");
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'Custom Graph.png';
        link.click();
    });
}

  getCalcData() {
    if (
      this.field1 == undefined &&
      this.field2 == undefined &&
      this.field3 == undefined
    ) {
      alert('Select atleast one field');
      return;
    } 
    else {
      this.EventlogsService.getEventLogsListByTrainId(this.trainId).subscribe({
        next: (response) => {
          this.Eventlogs = response;
          console.log(this.Eventlogs);
        },
      });
      

   
   if( this.opCalData.length==0)
   {
     
      this.opdataService.GetOPCalcdataNew(this.trainId).subscribe({
        next: (response) => {
          this.opCalData = response; 
          
         
          let x: Date[] = []; 
          let y: number[] = []; 
          let y1: number[] = []; 
          let y2: number[] = []; 
          let y1name = '';
          let y2name = '';
          let y3name = '';
          let yaxisname = '';
          let y1Event: string[] = [];
          let eventdate: string[] = [];
          if (this.field1 == '' && this.field2 == '' && this.field3 == '') {
            alert('Select atleast one type');
            return;
          }

          if (this.field1 != '') {
            y1name = this.fieldDDl.filter((x) => x.value == this.field1)[0]
              .label;
          }

          if (this.field2 != '') {
            y2name = this.fieldDDl.filter((x) => x.value == this.field2)[0]
              .label;
          }

          if (this.field3 != '') {
            y3name = this.fieldDDl.filter((x) => x.value == this.field3)[0]
              .label;
          }
 
          this.opCalData.forEach((element) => {
        
            x.push(new Date(element.Datetime));
            if (this.field1 != '') {
              switch (this.field1) {
                case 'temp': {
                  y.push(element.FeedTemp);
                  break;
                }
                case 'ph': {
                  {
                    y.push(element.Ph);
                  }

                  break;
                }
                case 'feed_cond': {
                  if (this.Stage1 == '1') {
                    //total
                    y.push(element.S1FeedCond); // feed conductivity is null for stage 2 and stage 3 so total feed conductivity = stage1 feed conductivity.
                  } else if (this.Stage1 == '2') {
                    //stage 1
                    y.push(element.S1FeedCond);
                  } else if (this.Stage1 == '3') {
                    //stage 2
                    y.push(element.S2FeedCond);
                  } //stage 3
                  else {
                    y.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (this.Stage1 == '1') {
                    //total
                    y.push(element.TotalFeedFlow);
                  } else if (this.Stage1 == '2') {
                    //stage 1
                    y.push(element.S1FeedFlow); //stage 2
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2FeedFlow);
                  } else {
                    y.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (this.Stage1 == '1') {
                    y.push(element.S1FeedPress);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1FeedPress);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2FeedPress);
                  } else {
                    y.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalConcFlow);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1ConcFlow);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2ConcFlow);
                  } else {
                    y.push(element.S3ConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (this.Stage1 == '1') {
                    y.push(element.S1ConcPress);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1ConcPress);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2ConcPress);
                  } else {
                    y.push(element.S3ConcPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalPermCond);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1PermCond);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2PermCond);
                  } else {
                    y.push(element.S3PermCond);
                  }
                  break;
                }
                
                case 'perm_flow': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalPermFlow);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1PermFlow);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2PermFlow);
                  } else {
                    y.push(element.S3PermFlow);
                  }
                  break;
                }
                case 'perm_press': {
                  if (this.Stage1 == '1') {
                    y.push(element.S1PermPress);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1PermPress);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2PermPress);
                  } else {
                    y.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalRecovery * 100);
                  } 
                  else if (this.Stage1 == '2') 
                      {
                       y.push(element.S1Recovery * 100) ;
                    } 
                  else if (this.Stage1 == '3') 
                    {
                      y.push(element.S2Recovery * 100);
                    } 
                  else 
                    {
                    y.push(element.S3Recovery * 100);
                    }
                  break;
                }
                case 'flux': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalFlux);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Flux);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Flux);
                  } else {
                    y.push(element.S3Flux);
                  }
                  break;
                }
               
                case 'dp': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalDiffPressure);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1DiffPressure);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2DiffPressure);
                  } else {
                    y.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalTmp);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Tmp);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Tmp);
                  } else {
                    y.push(element.S3Tmp);
                  }
                  break;
                }
                case 'feed_tds': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalFeedTds);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1FeedTds);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2FeedTds);
                  } else {
                    y.push(element.S3FeedTds);
                  }
                  break;
                }
                case 'perm_tds': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalPermTds);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1PermTds);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2PermTds);
                  } else {
                    y.push(element.S3PermTds);
                  }
                  break;
                }
                case 'aftds': {
                  if (this.Stage1 == '1') {
                    y.push(element.S1Aftds);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Aftds);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Aftds);
                  } else {
                    y.push(0);
                  }
                  break;
                }
                case 'afop': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalAvgFeedOp);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1AvgFeedOp);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2AvgFeedOp);
                  } else {
                    y.push(element.S3AvgFeedOp);
                  }
                  break;
                }
                case 'pop': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalPop);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Pop);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Pop);
                  } else {
                    y.push(element.S3Pop);
                  }
                  break;
                }
                case 'net_driv_press': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalNetDrivPress);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1NetDrivePressure);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2NetDrivPress);
                  } else {
                    y.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalAVal);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1AVal);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2AVal);
                  } else {
                    y.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalBVal);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1BVal);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2BVal);
                  } else {
                    y.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalNpf);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Npf);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Npf);
                  } else {
                    y.push(element.S3Npf);
                  }
                  break;
                }
                case 'nsp': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalNsp * 100 );
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Nsp * 100 );
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Nsp * 100);
                  } else {
                    y.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'ud1': {
                
                    y.push(element.Ud1);
                 
                  break;
                }
                case 'ud2': {
                
                    y.push(element.Ud2);
                 
                  break;
                }
                case 'ud3': {
                  
                    y.push(element.Ud3);
                  
                  break;
                }
                case 'ud4': {
                  
                    y.push(element.Ud4);
                 
                  break;
                }
                case 'ud5': {
                  
                    y.push(element.Ud5);
                  
                  break;
                }
                case 'norm_diff_press': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalNormDiffPress);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1NormDiffPress);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2NormDiffPress);
                  } else {
                    y.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  //statements;
                  break;
                }
              }
            }

            if (this.field2 != '') {
              switch (this.field2) {
                case 'temp': {
                  if (this.Stage2 == '1') {
                    y1.push(element.Temp);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.Temp);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.Temp);
                  } else {
                    y1.push(element.Temp);
                  }
                  break;
                }
                case 'ph': {
                  if (this.Stage1 == '1') {
                    y1.push(element.Ph);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.Ph);
                  } else if (this.Stage3 == '3') {
                    y1.push(element.Ph);
                  } else {
                    y1.push(element.Ph);
                  }
                  break;
                }
                case 'feed_cond': {
                  if (this.Stage2 == '1') {
                    y1.push(element.S1FeedCond);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1FeedCond);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2FeedCond);
                  } else {
                    y1.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalFeedFlow);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1FeedFlow);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2FeedFlow);
                  } else {
                    y1.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (this.Stage2 == '1') {
                    y1.push(element.S1FeedPress);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1FeedPress);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2FeedPress);
                  } else {
                    y1.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalConcFlow);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1ConcFlow);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2ConcFlow);
                  } else {
                    y1.push(element.S3ConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (this.Stage2 == '1') {
                    y1.push(element.S1ConcPress);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1ConcPress);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2ConcPress);
                  } else {
                    y1.push(element.S3ConcPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalPermCond);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1PermCond);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2PermCond);
                  } else {
                    y1.push(element.S3PermCond);
                  }
                  break;
                }
                case 'perm_flow': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalPermFlow);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1PermFlow);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2PermeateFlow);
                  } else {
                    y1.push(element.S3PermeateFlow);
                  }
                  break;
                }
                case 'ud1': {
                  y1.push(element.Ud1);
                  break;
                }
                case 'ud2': {
                  y1.push(element.Ud2);
                  break;
                }
                case 'ud3': {
                  y1.push(element.Ud3);
                  break;
                }
                case 'ud4': {
                  y1.push(element.Ud4);
                  break;
                }
                case 'ud5': {
                  y1.push(element.Ud5);
                  break;
                }
                case 'perm_press': {
                  if (this.Stage2 == '1') {
                    y1.push(element.S1PermPress);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1PermPress);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2PermPress);
                  } else {
                    y1.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalRecovery * 100);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Recovery * 100);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Recovery * 100);
                  } else {
                    y1.push(element.S3Recovery * 100);
                  }
                  break;
                }
                case 'flux': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalFlux);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Flux);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Flux);
                  } else {
                    y1.push(element.S3Flux);
                  }
                  break;
                }
                case 'dp': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalDiffPressure);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1DiffPressure);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2DiffPressure);
                  } else {
                    y1.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalTmp);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Tmp);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Tmp);
                  } else {
                    y1.push(element.S3Tmp);
                  }
                  break;
                }
                case 'feed_tds': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalFeedTds);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1FeedTds);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2FeedTds);
                  } else {
                    y1.push(element.S3FeedTds);
                  }
                  break;
                }
                case 'perm_tds': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalPermTds);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1PermTds);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2PermTds);
                  } else {
                    y1.push(element.S3PermTds);
                  }
                  break;
                }
                case 'aftds': {
                  if (this.Stage2 == '1') {
                    y1.push(element.S1Aftds);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Aftds);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Aftds);
                  } else {
                    y1.push(0);
                  }
                  break;
                }
                case 'afop': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalAvgFeedOp);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1AvgFeedOp);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2AvgFeedOp);
                  } else {
                    y1.push(element.S3AvgFeedOp);
                  }
                  break;
                }
                case 'pop': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalPop);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Pop);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Pop);
                  } else {
                    y1.push(element.S3Pop);
                  }
                  break;
                }
                case 'net_driv_press': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalNetDrivPress);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1NetDrivPress);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2NetDrivPress);
                  } else {
                    y1.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalAVal);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S3AVal);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2AVal);
                  } else {
                    y1.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalBVal);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1BVal);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2BVal);
                  } else {
                    y1.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalNpf);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Npf);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Npf);
                  } else {
                    y1.push(element.S3Npf);
                  }
                  break;
                }
               
                case 'nsp': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalNsp * 100);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Nsp * 100);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Nsp * 100);
                  } else {
                    y1.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'norm_diff_press': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalNormDiffPress);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1NormDiffPress);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2NormDiffPress);
                  } else {
                    y1.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  //statements;
                  break;
                }
              }
            }

            if (this.field3 != '') {
              switch (this.field3) {
                case 'temp': {
                  if (this.Stage3 == '1') {
                    y2.push(element.Temp);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.Temp);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.Temp);
                  } else {
                    y2.push(element.Temp);
                  }
                  break;
                }
                case 'ph': {
                  if (this.Stage3 == '1') {
                    y2.push(element.Ph);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.Ph);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.Ph);
                  } else {
                    y2.push(element.Ph);
                  }
                  break;
                }
                case 'feed_cond': {
                  if (this.Stage3 == '1') {
                    y2.push(element.S1FeedCond);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1FeedCond);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2FeedCond);
                  } else {
                    y2.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalFeedFlow);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1FeedFlow);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S1FeedFlow);
                  } else {
                    y2.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (this.Stage3 == '1') {
                    y2.push(element.S1FeedPress);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1FeedPress);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2FeedPress);
                  } else {
                    y2.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalConcFlow);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1ConcFlow);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S1ConcFlow);
                  } else {
                    y2.push(element.S3ConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (this.Stage3 == '1') {
                    y2.push(element.S1ConcPress);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1ConcPress);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2PermPress);
                  } else {
                    y2.push(element.S2PermPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalPermCond);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1PermCond);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2PermCond);
                  } else {
                    y2.push(element.S3PermConductivity);
                  }
                  break;
                }
                case 'perm_flow': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalPermFlow);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1PermFlow);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2PermFlow);
                  } else {
                    y2.push(element.S3PermFlow);
                  }
                  break;
                }
                case 'ud1': {
                  y2.push(element.Ud1);
                  break;
                }
                case 'ud2': {
                  y2.push(element.Ud2);
                  break;
                }
                case 'ud3': {
                  y2.push(element.Ud3);
                  break;
                }
                case 'ud4': {
                  y2.push(element.Ud4);
                  break;
                }
                case 'ud5': {
                  y2.push(element.Ud5);
                  break;
                }
                case 'perm_press': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalPermPress);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1PermPress);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2PermPress);
                  } else {
                    y2.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalRecovery *100);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Recovery * 100);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Recovery * 100);
                  } else {
                    y2.push(element.S3Recovery * 100);
                  }
                  break;
                }
                case 'flux': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalFlux);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Flux);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Flux);
                  } else {
                    y2.push(element.S3Flux);
                  }
                  break;
                }
                case 'dp': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalDiffPressure);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1DiffPressure);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2DiffPressure);
                  } else {
                    y2.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalTmp);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Tmp);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Tmp);
                  } else {
                    y2.push(element.S3Tmp);
                  }
                  break;
                }
                case 'feed_tds': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalFeedTds);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1FeedTds);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2FeedTds);
                  } else {
                    y2.push(element.S3FeedTds);
                  }
                  break;
                }
                case 'perm_tds': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalPermTds);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1PermTds);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2PermTds);
                  } else {
                    y2.push(element.S3PermTds);
                  }
                  break;
                }
                case 'aftds': {
                  if (this.Stage3 == '1') {
                    y2.push(element.S1Aftds);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Aftds);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Aftds);
                  } else {
                    y2.push(0);
                  }
                  break;
                }
                case 'afop': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalAvgFeedOp);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1AvgFeedOp);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2AvgFeedOp);
                  } else {
                    y2.push(element.S3AvgFeedOp);
                  }
                  break;
                }
                case 'pop': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalPop);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Pop);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Pop);
                  } else {
                    y2.push(element.S3Pop);
                  }
                  break;
                }
                case 'ud1': {
                  //if (element.Ud1 != null && element.Ud1 != 0) {
                    y2.push(element.Ud1);
                 // }
                  break;
                }
                case 'ud2': {
                  //if (element.Ud2 != null && element.Ud2 != 0) {
                    y2.push(element.Ud2);
                  //}
                  break;
                }
                case 'ud3': {
                  //if (element.Ud3 != null && element.Ud3 != 0) {
                    y2.push(element.Ud3);
                  //}
                  break;
                }
                case 'ud4': {
                  //if (element.Ud4 != null && element.Ud4 != 0) {
                    y2.push(element.Ud4);
                 // }
                  break;
                }
                case 'ud5': {
                 // if (element.Ud5 != null && element.Ud5 != 0) {
                    y2.push(element.Ud5);
                  //}
                  break;
                }
                case 'net_driv_press': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalNetDrivPress);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1NetDrivPress);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2NetDrivPress);
                  } else {
                    y2.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalAVal);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1AVal);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2AVal);
                  } else {
                    y2.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalBVal);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1BVal);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2BVal);
                  } else {
                    y2.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalNpf);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Npf);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Npf);
                  } else {
                    y2.push(element.S3Npf);
                  }
                  break;
                }
                case 'nsp': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalNsp * 100);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Nsp * 100);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Nsp * 100);
                  } else {
                    y2.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'norm_diff_press': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalNormDiffPress);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1NormDiffPress);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2NormDiffPress);
                  } else {
                    y2.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  
                  break;
                }
              }
            }
          });
          //get events
          this.Eventlogs.forEach((element) => {
            y1Event.push(
              element.Datetime.replace('T', ' ') +
                ' ' +
                element.EventType +
                ' ' +
                element.Observations
            );
            eventdate.push(element.Datetime.replace('T', ' '));
          });
         
          this.graphName =
            this.plantName +
            '/' +
            this.trainDetails.Name +
            '<br/>' +
            this.trainDetails.Systemconfig;

        
          //check if event exists for selected train
          if (y1Event.length > 0) 
          {
            const stageLabel1 = this.getStageLabel(this.Stage1);
            const stageLabel2 = this.getStageLabel(this.Stage2);
            const stageLabel3 = this.getStageLabel(this.Stage3);
            //if all fields are selected(3 Y axis)
            if (this.field1 != '' && this.field2 != '' && this.field3 != '') {
              this.F1Name = this.fieldDDl.filter(
                (x) => x.value == this.field1
              )[0].label;
              const fieldName1 = this.getFieldName(this.Stage1, this.field1);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName1]),
                Number.NEGATIVE_INFINITY
              );
              
              this.F2Name = this.fieldDDl.filter(
                (x) => x.value == this.field2
              )[0].label;
              const fieldName2 = this.getFieldName(this.Stage1, this.field2);
              this.maxField2 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName2]),
                Number.NEGATIVE_INFINITY
              );

              this.F3Name = this.fieldDDl.filter(
                (x) => x.value == this.field3
              )[0].label;
              const fieldName3 = this.getFieldName(this.Stage1, this.field3);
              this.maxField3 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName3]),
                Number.NEGATIVE_INFINITY
              );

              let maxnumber = Math.max(
                this.maxField1,
                this.maxField2,
                this.maxField3
              );
              this.maxField1 = maxnumber;
              this.plot.plotLineCustomGraphWithEvents(
                '',
                'plot',
                x,
                y,
                y1,
                y2,
                'F1:' + y1name,
                'F2:' + y2name,
                'F3:' + y3name,
                y1Event,
                eventdate,
                this.maxField1,
                 stageLabel1,
  stageLabel2,
  stageLabel3
              );
            }
            //if only  field one is selected(1 Y axis)
            if (this.field1 != '' && this.field2 == '' && this.field3 == '') {
              this.F1Name = this.fieldDDl.filter(
                (x) => x.value == this.field1
              )[0].label;
              const fieldName1 = this.getFieldName(this.Stage1, this.field1);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName1]),
                Number.NEGATIVE_INFINITY
              );
              yaxisname = y1name;
              this.plot.plotLineWithEvents(
                '',
                'plot',
                x,
                y,
                'F1:' + yaxisname,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1,
              );
            }
            if (this.field1 == '' && this.field2 != '' && this.field3 == '') {
              this.F2Name = this.fieldDDl.filter(
                (x) => x.value == this.field1
              )[0].label;
              const fieldName1 = this.getFieldName(this.Stage1, this.field1);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName1]),
                Number.NEGATIVE_INFINITY
              );
              yaxisname = y2name;
              this.plot.plotLineWithEvents(
                '',
                'plot',
                x,
                y1,
                'F1:' + yaxisname,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1
              );
            }
            if (this.field1 == '' && this.field2 == '' && this.field3 != '') {
              this.F3Name = this.fieldDDl.filter(
                (x) => x.value == this.field3
              )[0].label;
              const fieldName3 = this.getFieldName(this.Stage1, this.field3);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName3]),
                Number.NEGATIVE_INFINITY
              );
              yaxisname = y3name;
              this.plot.plotLineWithEvents(
                '',
                'plot',
                x,
                y2,
                'F3:' + yaxisname,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1
              );
            }
           
            if (this.field1 == '' && this.field2 == '' && this.field3 != '') {
              this.F3Name = this.fieldDDl.filter(
                (x) => x.value == this.field3
              )[0].label;
              const fieldName3 = this.getFieldName(this.Stage1, this.field3);
              this.maxField3 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName3]),
                Number.NEGATIVE_INFINITY
              );

              yaxisname = y3name;
              this.plot.plotLineWithEvents(
                '',
                'plot',
                x,
                y2,
                'F3:' + yaxisname,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1
              );
            }
            //if only field 1 and field2 is selected(2 Y axis with events)
            if (this.field1 != '' && this.field2 != '' && this.field3 == '') {
              this.F1Name = this.fieldDDl.filter(
                (x) => x.value == this.field1
              )[0].label;
              const fieldName1 = this.getFieldName(this.Stage1, this.field1);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName1]),
                Number.NEGATIVE_INFINITY
              );

              this.F2Name = this.fieldDDl.filter(
                (x) => x.value == this.field2
              )[0].label;
              const fieldName2 = this.getFieldName(this.Stage1, this.field2);
              this.maxField2 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName2]),
                Number.NEGATIVE_INFINITY
              );
              let maxnumber = Math.max(this.maxField1, this.maxField2);
              this.maxField1 = maxnumber;
              this.plot.plotTwoLineCustomGraphWithF1andF2WithEvents(
             //this.plot.plotCustomForF1andF2ForEventsFinal(
                '',
                'plot',
                x,
                y1,
                y,
                'F1:' + y1name,
                'F2:' + y2name, 
                 
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1,
                stageLabel2
              );
            }
            
            //if only field 1 and field3 is selected(2 Y axis with events)
            if (this.field1 != '' && this.field2 == '' && this.field3 != '') {
              this.F1Name = this.fieldDDl.filter(
                (x) => x.value == this.field1
              )[0].label;
              const fieldName1 = this.getFieldName(this.Stage1, this.field1);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName1]),
                Number.NEGATIVE_INFINITY
              );

              this.F3Name = this.fieldDDl.filter(
                (x) => x.value == this.field3
              )[0].label;
              const fieldName3 = this.getFieldName(this.Stage1, this.field3);
              this.maxField3 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName3]),
                Number.NEGATIVE_INFINITY
              );
              let maxnumber = Math.max(this.maxField1, this.maxField3);
              this.maxField1 = maxnumber;
              this.plot.plotTwoLineCustomGraphWithF1and3WithEvents(
                '',
                'plot',
                x,
                y2,
                y,
                'F1:' + y1name,
                'F3:' + y3name,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1,
                stageLabel3
              );
            }
            //if only field2 and field3 is selected(2 Y axis with events)
            if (this.field1 == '' && this.field2 != '' && this.field3 != '') {
              this.F2Name = this.fieldDDl.filter(
                (x) => x.value == this.field2
              )[0].label;
              const fieldName2 = this.getFieldName(this.Stage1, this.field2);
              this.maxField2 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName2]),
                Number.NEGATIVE_INFINITY
              );

              this.F3Name = this.fieldDDl.filter(
                (x) => x.value == this.field3
              )[0].label;
              const fieldName3 = this.getFieldName(this.Stage1, this.field3);
              this.maxField3 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName3]),
                Number.NEGATIVE_INFINITY
              );
              let maxnumber = Math.max(this.maxField2, this.maxField3);
              this.maxField1 = maxnumber;
              this.plot.plotTwoLineCustomGraphWithF2and3WithEvents(
                '',
                'plot',
                x,
                y2,
                y1,
                'F2:' + y2name,
                'F3:' + y3name,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel2,
                stageLabel3
              );
            }
          } 
          else {
             const stageLabel1 = this.getStageLabel(this.Stage1);
            const stageLabel2 = this.getStageLabel(this.Stage2);
            const stageLabel3 = this.getStageLabel(this.Stage3);
            //graph with 3 Y axis
            if (this.field1 != '' && this.field2 != '' && this.field3 != '') {
              this.plot.plotLineCustomGraph(
                '',
                'plot',
                x,
                y,
                y1,
                y2,
                'F1:' + y1name,
                'F2:' + y2name,
                'F3:' + y3name,
                stageLabel1,
                stageLabel2,
                stageLabel3
              );
            }

            //graph with 1 Y axis.
            if (this.field1 != '' && this.field2 == '' && this.field3 == '') {
              yaxisname = y1name;
              this.plot.plotLine('', 'plot', x, y, 'F1:' + yaxisname,stageLabel1);
            }

            if (this.field1 == '' && this.field2 != '' && this.field3 == '') {
              yaxisname = y2name;
              this.plot.plotLine('', 'plot', x, y1, 'F2:' + yaxisname,stageLabel1);
            }

            if (this.field1 == '' && this.field2 == '' && this.field3 != '') {
              yaxisname = y3name;
              this.plot.plotLine('', 'plot', x, y2, 'F3:' + yaxisname,stageLabel1);
            }

            //graph with 2 Y axis
            if (this.field1 != '' && this.field2 != '' && this.field3 == '') {
              //this.plot.plotTwoLineCustomGraphWithF1andF2(
             this.plot.plotf1andf2custom(
                '',
                'plot',
                x,
                y1,
                y,
                'F1:' + y1name,
                'F2:' + y2name,
                stageLabel1,
                stageLabel2
              );
            }
            if (this.field1 != '' && this.field2 == '' && this.field3 != '') {
              this.plot.plotTwoLineCustomGraphF1andF3(
                '',
                'plot',
                x,
                y2,
                y,
                'F1:' + y1name,
                'F3:' + y3name,
                 stageLabel1,
                stageLabel3
              );
            }

            if (this.field1 == '' && this.field2 != '' && this.field3 != '') {
              this.plot.plotTwoLineCustomGraphF2andF3(
                '',
                'plot',
                x,
                y2,
                y1,
                'F2:' + y2name,
                'F3:' + y3name,
                stageLabel2,
                stageLabel3
              );
            }
          }
        },
      });
    }
    else
    {
      let x: Date[] = []; 
          let y: number[] = []; 
          let y1: number[] = []; 
          let y2: number[] = []; 
          let y1name = '';
          let y2name = '';
          let y3name = '';
          let yaxisname = '';
          let y1Event: string[] = [];
          let eventdate: string[] = [];
          if (this.field1 == '' && this.field2 == '' && this.field3 == '') {
            alert('Select atleast one type');
            return;
          }

          if (this.field1 != '') {
            y1name = this.fieldDDl.filter((x) => x.value == this.field1)[0]
              .label;
          }

          if (this.field2 != '') {
            y2name = this.fieldDDl.filter((x) => x.value == this.field2)[0]
              .label;
          }

          if (this.field3 != '') {
            y3name = this.fieldDDl.filter((x) => x.value == this.field3)[0]
              .label;
          }
 
          this.opCalData.forEach((element) => {
         
            x.push(new Date(element.Datetime));
            if (this.field1 != '') {
              switch (this.field1) {
                case 'temp': {
                  y.push(element.FeedTemp);
                  break;
                }
                case 'ph': {
                  {
                    y.push(element.Ph);
                  }

                  break;
                }
                case 'feed_cond': {
                  if (this.Stage1 == '1') {
                    //total
                    y.push(element.S1FeedCond); // feed conductivity is null for stage 2 and stage 3 so total feed conductivity = stage1 feed conductivity.
                  } else if (this.Stage1 == '2') {
                    //stage 1
                    y.push(element.S1FeedCond);
                  } else if (this.Stage1 == '3') {
                    //stage 2
                    y.push(element.S2FeedCond);
                  } //stage 3
                  else {
                    y.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (this.Stage1 == '1') {
                    //total
                    y.push(element.TotalFeedFlow);
                  } else if (this.Stage1 == '2') {
                    //stage 1
                    y.push(element.S1FeedFlow); //stage 2
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2FeedFlow);
                  } else {
                    y.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (this.Stage1 == '1') {
                    y.push(element.S1FeedPress);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1FeedPress);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2FeedPress);
                  } else {
                    y.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalConcFlow);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1ConcFlow);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2ConcFlow);
                  } else {
                    y.push(element.S3ConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (this.Stage1 == '1') {
                    y.push(element.S1ConcPress);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1ConcPress);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2ConcPress);
                  } else {
                    y.push(element.S3ConcPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalPermCond);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1PermCond);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2PermCond);
                  } else {
                    y.push(element.S3PermCond);
                  }
                  break;
                }
                
                case 'perm_flow': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalPermFlow);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1PermFlow);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2PermFlow);
                  } else {
                    y.push(element.S3PermFlow);
                  }
                  break;
                }
                case 'perm_press': {
                  if (this.Stage1 == '1') {
                    y.push(element.S1PermPress);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1PermPress);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2PermPress);
                  } else {
                    y.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalRecovery * 100);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Recovery * 100);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Recovery * 100);
                  } else {
                    y.push(element.S3Recovery * 100);
                  }
                  break;
                }
                case 'flux': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalFlux);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Flux);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Flux);
                  } else {
                    y.push(element.S3Flux);
                  }
                  break;
                }
               
                case 'dp': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalDiffPressure);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1DiffPressure);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2DiffPressure);
                  } else {
                    y.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalTmp);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Tmp);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Tmp);
                  } else {
                    y.push(element.S3Tmp);
                  }
                  break;
                }
                case 'feed_tds': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalFeedTds);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1FeedTds);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2FeedTds);
                  } else {
                    y.push(element.S3FeedTds);
                  }
                  break;
                }
                case 'perm_tds': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalPermTds);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1PermTds);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2PermTds);
                  } else {
                    y.push(element.S3PermTds);
                  }
                  break;
                }
                case 'aftds': {
                  if (this.Stage1 == '1') {
                    y.push(element.S1Aftds);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Aftds);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Aftds);
                  } else {
                    y.push(0);
                  }
                  break;
                }
                case 'afop': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalAvgFeedOp);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1AvgFeedOp);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2AvgFeedOp);
                  } else {
                    y.push(element.S3AvgFeedOp);
                  }
                  break;
                }
                case 'pop': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalPop);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Pop);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Pop);
                  } else {
                    y.push(element.S3Pop);
                  }
                  break;
                }
                case 'net_driv_press': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalNetDrivPress);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1NetDrivePressure);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2NetDrivPress);
                  } else {
                    y.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalAVal);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1AVal);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2AVal);
                  } else {
                    y.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalBVal);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1BVal);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2BVal);
                  } else {
                    y.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalNpf);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Npf);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Npf);
                  } else {
                    y.push(element.S3Npf);
                  }
                  break;
                }
                case 'nsp': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalNsp * 100);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1Nsp * 100);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2Nsp * 100);
                  } else {
                    y.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'ud1': {
                  if (element.Ud1 != null && element.Ud1 != 0) {
                    y.push(element.Ud1);
                  }
                  break;
                }
                case 'ud2': {
                  if (element.Ud2 != null && element.Ud2 != 0) {
                    y.push(element.Ud2);
                  }
                  break;
                }
                case 'ud3': {
                  if (element.Ud3 != null && element.Ud3 != 0) {
                    y.push(element.Ud3);
                  }
                  break;
                }
                case 'ud4': {
                  if (element.Ud4 != null && element.Ud4 != 0) {
                    y.push(element.Ud4);
                  }
                  break;
                }
                case 'ud5': {
                  
                    y.push(element.Ud5);
                  
                  break;
                }
                case 'norm_diff_press': {
                  if (this.Stage1 == '1') {
                    y.push(element.TotalNormDiffPress);
                  } else if (this.Stage1 == '2') {
                    y.push(element.S1NormDiffPress);
                  } else if (this.Stage1 == '3') {
                    y.push(element.S2NormDiffPress);
                  } else {
                    y.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  //statements;
                  break;
                }
              }
            }

            if (this.field2 != '') {
              switch (this.field2) {
                case 'temp': {
                  if (this.Stage2 == '1') {
                    y1.push(element.Temp);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.Temp);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.Temp);
                  } else {
                    y1.push(element.Temp);
                  }
                  break;
                }
                case 'ph': {
                  if (this.Stage1 == '1') {
                    y1.push(element.Ph);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.Ph);
                  } else if (this.Stage3 == '3') {
                    y1.push(element.Ph);
                  } else {
                    y1.push(element.Ph);
                  }
                  break;
                }
                case 'feed_cond': {
                  if (this.Stage2 == '1') {
                    y1.push(element.S1FeedCond);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1FeedCond);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2FeedCond);
                  } else {
                    y1.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalFeedFlow);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1FeedFlow);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2FeedFlow);
                  } else {
                    y1.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (this.Stage2 == '1') {
                    y1.push(element.S1FeedPress);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1FeedPress);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2FeedPress);
                  } else {
                    y1.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalConcFlow);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1ConcFlow);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2ConcFlow);
                  } else {
                    y1.push(element.S3ConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (this.Stage2 == '1') {
                    y1.push(element.S1ConcPress);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1ConcPress);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2ConcPress);
                  } else {
                    y1.push(element.S3ConcPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalPermCond);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1PermCond);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2PermCond);
                  } else {
                    y1.push(element.S3PermCond);
                  }
                  break;
                }
                case 'perm_flow': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalPermFlow);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1PermFlow);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2PermeateFlow);
                  } else {
                    y1.push(element.S3PermeateFlow);
                  }
                  break;
                }
                case 'ud1': {
                  y1.push(element.Ud1);
                  break;
                }
                case 'ud2': {
                  y1.push(element.Ud2);
                  break;
                }
                case 'ud3': {
                  y1.push(element.Ud3);
                  break;
                }
                case 'ud4': {
                  y1.push(element.Ud4);
                  break;
                }
                case 'ud5': {
                  y1.push(element.Ud5);
                  break;
                }
                case 'perm_press': {
                  if (this.Stage2 == '1') {
                    y1.push(element.S1PermPress);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1PermPress);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2PermPress);
                  } else {
                    y1.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalRecovery * 100);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Recovery * 100);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Recovery * 100);
                  } else {
                    y1.push(element.S3Recovery * 100);
                  }
                  break;
                }
                case 'flux': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalFlux);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Flux);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Flux);
                  } else {
                    y1.push(element.S3Flux);
                  }
                  break;
                }
                case 'dp': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalDiffPressure);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1DiffPressure);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2DiffPressure);
                  } else {
                    y1.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalTmp);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Tmp);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Tmp);
                  } else {
                    y1.push(element.S3Tmp);
                  }
                  break;
                }
                case 'feed_tds': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalFeedTds);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1FeedTds);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2FeedTds);
                  } else {
                    y1.push(element.S3FeedTds);
                  }
                  break;
                }
                case 'perm_tds': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalPermTds);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1PermTds);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2PermTds);
                  } else {
                    y1.push(element.S3PermTds);
                  }
                  break;
                }
                case 'aftds': {
                  if (this.Stage2 == '1') {
                    y1.push(element.S1Aftds);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Aftds);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Aftds);
                  } else {
                    y1.push(0);
                  }
                  break;
                }
                case 'afop': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalAvgFeedOp);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1AvgFeedOp);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2AvgFeedOp);
                  } else {
                    y1.push(element.S3AvgFeedOp);
                  }
                  break;
                }
                case 'pop': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalPop);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Pop);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Pop);
                  } else {
                    y1.push(element.S3Pop);
                  }
                  break;
                }
                case 'net_driv_press': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalNetDrivPress);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1NetDrivPress);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2NetDrivPress);
                  } else {
                    y1.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalAVal);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S3AVal);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2AVal);
                  } else {
                    y1.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalBVal);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1BVal);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2BVal);
                  } else {
                    y1.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalNpf);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Npf);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Npf);
                  } else {
                    y1.push(element.S3Npf);
                  }
                  break;
                }
               
                case 'nsp': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalNsp * 100);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1Nsp * 100);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2Nsp * 100);
                  } else {
                    y1.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'norm_diff_press': {
                  if (this.Stage2 == '1') {
                    y1.push(element.TotalNormDiffPress);
                  } else if (this.Stage2 == '2') {
                    y1.push(element.S1NormDiffPress);
                  } else if (this.Stage2 == '3') {
                    y1.push(element.S2NormDiffPress);
                  } else {
                    y1.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  //statements;
                  break;
                }
              }
            }

            if (this.field3 != '') {
              switch (this.field3) {
                case 'temp': {
                  if (this.Stage3 == '1') {
                    y2.push(element.Temp);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.Temp);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.Temp);
                  } else {
                    y2.push(element.Temp);
                  }
                  break;
                }
                case 'ph': {
                  if (this.Stage3 == '1') {
                    y2.push(element.Ph);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.Ph);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.Ph);
                  } else {
                    y2.push(element.Ph);
                  }
                  break;
                }
                case 'feed_cond': {
                  if (this.Stage3 == '1') {
                    y2.push(element.S1FeedCond);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1FeedCond);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2FeedCond);
                  } else {
                    y2.push(element.S3FeedCond);
                  }
                  break;
                }
                case 'feed_flow': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalFeedFlow);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1FeedFlow);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S1FeedFlow);
                  } else {
                    y2.push(element.S3FeedFlow);
                  }
                  break;
                }
                case 'feed_press': {
                  if (this.Stage3 == '1') {
                    y2.push(element.S1FeedPress);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1FeedPress);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2FeedPress);
                  } else {
                    y2.push(element.S3FeedPress);
                  }
                  break;
                }
                case 'conc_flow': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalConcFlow);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1ConcFlow);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S1ConcFlow);
                  } else {
                    y2.push(element.S3ConcFlow);
                  }
                  break;
                }
                case 'conc_press': {
                  if (this.Stage3 == '1') {
                    y2.push(element.S1ConcPress);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1ConcPress);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2PermPress);
                  } else {
                    y2.push(element.S2PermPress);
                  }
                  break;
                }
                case 'perm_cond': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalPermCond);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1PermCond);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2PermCond);
                  } else {
                    y2.push(element.S3PermConductivity);
                  }
                  break;
                }
                case 'perm_flow': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalPermFlow);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1PermFlow);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2PermFlow);
                  } else {
                    y2.push(element.S3PermFlow);
                  }
                  break;
                }
                case 'ud1': {
                  y2.push(element.Ud1);
                  break;
                }
                case 'ud2': {
                  y2.push(element.Ud2);
                  break;
                }
                case 'ud3': {
                  y2.push(element.Ud3);
                  break;
                }
                case 'ud4': {
                  y2.push(element.Ud4);
                  break;
                }
                case 'ud5': {
                  y2.push(element.Ud5);
                  break;
                }
                case 'perm_press': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalPermPress);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1PermPress);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2PermPress);
                  } else {
                    y2.push(element.S3PermPress);
                  }
                  break;
                }
                case 'recovery': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalRecovery * 100);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Recovery * 100);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Recovery * 100);
                  } else {
                    y2.push(element.S3Recovery * 100);
                  }
                  break;
                }
                case 'flux': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalFlux);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Flux);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Flux);
                  } else {
                    y2.push(element.S3Flux);
                  }
                  break;
                }
                case 'dp': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalDiffPressure);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1DiffPressure);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2DiffPressure);
                  } else {
                    y2.push(element.S3DiffPressure);
                  }
                  break;
                }
                case 'tmp': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalTmp);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Tmp);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Tmp);
                  } else {
                    y2.push(element.S3Tmp);
                  }
                  break;
                }
                case 'feed_tds': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalFeedTds);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1FeedTds);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2FeedTds);
                  } else {
                    y2.push(element.S3FeedTds);
                  }
                  break;
                }
                case 'perm_tds': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalPermTds);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1PermTds);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2PermTds);
                  } else {
                    y2.push(element.S3PermTds);
                  }
                  break;
                }
                case 'aftds': {
                  if (this.Stage3 == '1') {
                    y2.push(element.S1Aftds);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Aftds);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Aftds);
                  } else {
                    y2.push(0);
                  }
                  break;
                }
                case 'afop': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalAvgFeedOp);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1AvgFeedOp);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2AvgFeedOp);
                  } else {
                    y2.push(element.S3AvgFeedOp);
                  }
                  break;
                }
                case 'pop': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalPop);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Pop);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Pop);
                  } else {
                    y2.push(element.S3Pop);
                  }
                  break;
                }
                case 'ud1': {
                 
                    y2.push(element.Ud1);
                  
                  break;
                }
                case 'ud2': {
                 
                    y2.push(element.Ud2);
                 
                  break;
                }
                case 'ud3': {
                  
                    y2.push(element.Ud3);
                  
                  break;
                }
                case 'ud4': {
                 
                    y2.push(element.Ud4);
                  
                  break;
                }
                case 'ud5': {
                 
                    y2.push(element.Ud5);
                  
                  break;
                }
                case 'net_driv_press': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalNetDrivPress);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1NetDrivPress);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2NetDrivPress);
                  } else {
                    y2.push(element.S3NetDrivPress);
                  }
                  break;
                }
                case 'a_val': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalAVal);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1AVal);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2AVal);
                  } else {
                    y2.push(element.S3AVal);
                  }
                  break;
                }
                case 'b_val': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalBVal);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1BVal);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2BVal);
                  } else {
                    y2.push(element.S3BVal);
                  }
                  break;
                }
                case 'npf': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalNpf);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Npf);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Npf);
                  } else {
                    y2.push(element.S3Npf);
                  }
                  break;
                }
                case 'nsp': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalNsp * 100);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1Nsp * 100);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2Nsp * 100);
                  } else {
                    y2.push(element.S3Nsp * 100);
                  }
                  break;
                }
                case 'norm_diff_press': {
                  if (this.Stage3 == '1') {
                    y2.push(element.TotalNormDiffPress);
                  } else if (this.Stage3 == '2') {
                    y2.push(element.S1NormDiffPress);
                  } else if (this.Stage3 == '3') {
                    y2.push(element.S2NormDiffPress);
                  } else {
                    y2.push(element.S3NormDiffPress);
                  }
                  break;
                }
                default: {
                  //statements;
                  break;
                }
              }
            }
          });
          //get events
          this.Eventlogs.forEach((element) => {
            y1Event.push(
              element.Datetime.replace('T', ' ') +
                ' ' +
                element.EventType +
                ' ' +
                element.Observations
            );
            eventdate.push(element.Datetime.replace('T', ' '));
          });
         
          this.graphName =
            this.plantName +
            '/' +
            this.trainDetails.Name +
            '<br/>' +
            this.trainDetails.Systemconfig;


          //check if event exists for selected train
          if (y1Event.length > 0) 
          {
            const stageLabel1 = this.getStageLabel(this.Stage1);
            const stageLabel2 = this.getStageLabel(this.Stage2);
            const stageLabel3 = this.getStageLabel(this.Stage3);
            //if all fields are selected(3 Y axis)
            if (this.field1 != '' && this.field2 != '' && this.field3 != '') {
              this.F1Name = this.fieldDDl.filter(
                (x) => x.value == this.field1
              )[0].label;
              const fieldName1 = this.getFieldName(this.Stage1, this.field1);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName1]),
                Number.NEGATIVE_INFINITY
              );
              
              this.F2Name = this.fieldDDl.filter(
                (x) => x.value == this.field2
              )[0].label;
              const fieldName2 = this.getFieldName(this.Stage1, this.field2);
              this.maxField2 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName2]),
                Number.NEGATIVE_INFINITY
              );

              this.F3Name = this.fieldDDl.filter(
                (x) => x.value == this.field3
              )[0].label;
              const fieldName3 = this.getFieldName(this.Stage1, this.field3);
              this.maxField3 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName3]),
                Number.NEGATIVE_INFINITY
              );

              let maxnumber = Math.max(
                this.maxField1,
                this.maxField2,
                this.maxField3
              );
              this.maxField1 = maxnumber;
              this.plot.plotLineCustomGraphWithEvents(
                '',
                'plot',
                x,
                y,
                y1,
                y2,
                'F1:' + y1name,
                'F2:' + y2name,
                'F3:' + y3name,
                y1Event,
                eventdate,
                this.maxField1,
                  stageLabel1,
  stageLabel2,
  stageLabel3
              );
            }
            //if only  field one is selected(1 Y axis)
            if (this.field1 != '' && this.field2 == '' && this.field3 == '') {
              this.F1Name = this.fieldDDl.filter(
                (x) => x.value == this.field1
              )[0].label;
              const fieldName1 = this.getFieldName(this.Stage1, this.field1);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName1]),
                Number.NEGATIVE_INFINITY
              );
              yaxisname = y1name;
              this.plot.plotLineWithEvents(
                '',
                'plot',
                x,
                y,
                'F1:' + yaxisname,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1
              );
            }
            if (this.field1 == '' && this.field2 != '' && this.field3 == '') {
              this.F2Name = this.fieldDDl.filter(
                (x) => x.value == this.field1
              )[0].label;
              const fieldName1 = this.getFieldName(this.Stage1, this.field1);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName1]),
                Number.NEGATIVE_INFINITY
              );
              yaxisname = y2name;
              this.plot.plotLineWithEvents(
                '',
                'plot',
                x,
                y1,
                'F1:' + yaxisname,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1
              );
            }
            if (this.field1 == '' && this.field2 == '' && this.field3 != '') {
              this.F3Name = this.fieldDDl.filter(
                (x) => x.value == this.field3
              )[0].label;
              const fieldName3 = this.getFieldName(this.Stage1, this.field3);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName3]),
                Number.NEGATIVE_INFINITY
              );
              yaxisname = y3name;
              this.plot.plotLineWithEvents(
                '',
                'plot',
                x,
                y2,
                'F3:' + yaxisname,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1
              );
            }
           
            if (this.field1 == '' && this.field2 == '' && this.field3 != '') {
              this.F3Name = this.fieldDDl.filter(
                (x) => x.value == this.field3
              )[0].label;
              const fieldName3 = this.getFieldName(this.Stage1, this.field3);
              this.maxField3 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName3]),
                Number.NEGATIVE_INFINITY
              );

              yaxisname = y3name;
              this.plot.plotLineWithEvents(
                '',
                'plot',
                x,
                y2,
                'F3:' + yaxisname,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1
              );
            }
            //if only field 1 and field2 is selected(2 Y axis with events)
            if (this.field1 != '' && this.field2 != '' && this.field3 == '') {
              this.F1Name = this.fieldDDl.filter(
                (x) => x.value == this.field1
              )[0].label;
              const fieldName1 = this.getFieldName(this.Stage1, this.field1);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName1]),
                Number.NEGATIVE_INFINITY
              );

              this.F2Name = this.fieldDDl.filter(
                (x) => x.value == this.field2
              )[0].label;
              const fieldName2 = this.getFieldName(this.Stage1, this.field2);
              this.maxField2 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName2]),
                Number.NEGATIVE_INFINITY
              );
              let maxnumber = Math.max(this.maxField1, this.maxField2);
              this.maxField1 = maxnumber;
              this.plot.plotTwoLineCustomGraphWithF1andF2WithEvents(
             // this,this.plot.plotCustomForF1andF2ForEventsFinal(
                '',
                'plot',
                x,
                y1,
                y,
                'F1:' + y1name,
                'F2:' + y2name,
               
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1,
                stageLabel2
              );
            }
            //if only field 1 and field3 is selected(2 Y axis with events)
            if (this.field1 != '' && this.field2 == '' && this.field3 != '') {
              this.F1Name = this.fieldDDl.filter(
                (x) => x.value == this.field1
              )[0].label;
              const fieldName1 = this.getFieldName(this.Stage1, this.field1);
              this.maxField1 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName1]),
                Number.NEGATIVE_INFINITY
              );

              this.F3Name = this.fieldDDl.filter(
                (x) => x.value == this.field3
              )[0].label;
              const fieldName3 = this.getFieldName(this.Stage1, this.field3);
              this.maxField3 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName3]),
                Number.NEGATIVE_INFINITY
              );
              let maxnumber = Math.max(this.maxField1, this.maxField3);
              this.maxField1 = maxnumber;
              this.plot.plotTwoLineCustomGraphWithF1and3WithEvents(
                '',
                'plot',
                x,
                y2,
                y,
                'F1:' + y1name,
                'F3:' + y3name,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel1,
                stageLabel3
              );
            }
            //if only field2 and field3 is selected(2 Y axis with events)
            if (this.field1 == '' && this.field2 != '' && this.field3 != '') {
              this.F2Name = this.fieldDDl.filter(
                (x) => x.value == this.field2
              )[0].label;
              const fieldName2 = this.getFieldName(this.Stage1, this.field2);
              this.maxField2 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName2]),
                Number.NEGATIVE_INFINITY
              );

              this.F3Name = this.fieldDDl.filter(
                (x) => x.value == this.field3
              )[0].label;
              const fieldName3 = this.getFieldName(this.Stage1, this.field3);
              this.maxField3 = this.opCalData.reduce(
                (acc, item) => Math.max(acc, item[fieldName3]),
                Number.NEGATIVE_INFINITY
              );
              let maxnumber = Math.max(this.maxField2, this.maxField3);
              this.maxField1 = maxnumber;
              this.plot.plotTwoLineCustomGraphWithF2and3WithEvents(
                '',
                'plot',
                x,
                y2,
                y1,
                'F2:' + y2name,
                'F3:' + y3name,
                y1Event,
                eventdate,
                this.maxField1,
                stageLabel2,
                stageLabel3
              );
            }
          } 
          else {
            const stageLabel1 = this.getStageLabel(this.Stage1);
            const stageLabel2 = this.getStageLabel(this.Stage2);
            const stageLabel3 = this.getStageLabel(this.Stage3);
            //graph with 3 Y axis
            if (this.field1 != '' && this.field2 != '' && this.field3 != '') {
              this.plot.plotLineCustomGraph(
                '',
                'plot',
                x,
                y,
                y1,
                y2,
                'F1:' + y1name,
                'F2:' + y2name,
                'F3:' + y3name,
                stageLabel1,
                stageLabel2,
                stageLabel3
              );
            }

            //graph with 1 Y axis.
            if (this.field1 != '' && this.field2 == '' && this.field3 == '') {
              yaxisname = y1name;
              this.plot.plotLine('', 'plot', x, y, 'F1:' + yaxisname,stageLabel1);
            }

            if (this.field1 == '' && this.field2 != '' && this.field3 == '') {
              yaxisname = y2name;
              this.plot.plotLine('', 'plot', x, y1, 'F2:' + yaxisname,stageLabel1);
            }

            if (this.field1 == '' && this.field2 == '' && this.field3 != '') {
              yaxisname = y3name;
              this.plot.plotLine('', 'plot', x, y2, 'F3:' + yaxisname,stageLabel1);
            }

            //graph with 2 Y axis
            if (this.field1 != '' && this.field2 != '' && this.field3 == '') {
              this.plot.plotTwoLineCustomGraphWithF1andF2(
                '',
                'plot',
                x,
                y1,
                y,
                'F1:' + y1name,
                'F2:' + y2name,
                stageLabel1,
                stageLabel2
              );
            }
            if (this.field1 != '' && this.field2 == '' && this.field3 != '') {
              this.plot.plotTwoLineCustomGraphF1andF3(
                '',
                'plot',
                x,
                y,
                y2,
                'F1:' + y1name,
                'F3:' + y3name,
                stageLabel1,
                stageLabel3
              );
            }

            if (this.field1 == '' && this.field2 != '' && this.field3 != '') {
              this.plot.plotTwoLineCustomGraphF2andF3(
                '',
                'plot',
                x,
                y2,
                y1,
                'F2:' + y2name,
                'F3:' + y3name,
                stageLabel2,
                stageLabel3
              );
            }
          }

    }
  }
}

  getStageLabel(stageNumber: any): string {
    if (stageNumber == 1) return 'Total';
    if (stageNumber == 2) return 'Stage 1';
    if (stageNumber == 3) return 'Stage 2';
    if (stageNumber == 4) return 'Stage 3';
    return 'Total';
  }
}
